<div data-at-filters class="filter-chips flex flex-row gap-[{{ layoutGap }}]">
  <ng-content select="app-chip-filter"></ng-content>
</div>
